import supabaseClient from '@/api/supabaseClient.ts';
import { SupabaseClient } from '@supabase/supabase-js';
import { useQuery } from '@tanstack/react-query';
import { Restaurant } from '@/types/models/Restaurant';

type Filters =
  | {
      restaurant_id?: number | null;
    }
  | undefined;
const useRestaurants = (enabled: boolean = true, filters: Filters = undefined) => {
  const client = supabaseClient;
  const queryKey = ['restaurants', filters?.restaurant_id];

  const queryFn = async () => {
    return getRestaurants(client, filters);
  };

  return useQuery({
    queryKey,
    queryFn,
    enabled,
    staleTime: 1000 * 60 * 5,
  });
};

export default useRestaurants;

function getRestaurants(client: SupabaseClient, filters: Filters): Restaurant[] {
  let clientWithFilters = client
    .from('restaurants')
    .select(
      `
        id,
        name,
        address,
        phone,
        redirect_phone,
        timezone,
        weekday_hours_from,
        weekday_hours_to,
        weekend_hours_from,
        weekend_hours_to,
        bot_enabled,
        created_at
      `
    )
    .order('created_at', { ascending: true });

  if (filters?.restaurant_id) {
    clientWithFilters = clientWithFilters.eq('id', filters.restaurant_id);
  }

  return clientWithFilters.then((result: any) => result.data) as unknown as Restaurant[];
}
